import React from "react";
import { Globe } from "lucide-react";
import { useLang } from "@/i18n";

const langs = [{ k: "fr", l: "FR" }, { k: "nl", l: "NL" }, { k: "en", l: "EN" }];

export const BlogLangSwitcher = () => {
  const { lang, setLang } = useLang();
  return (
    <div className="flex items-center gap-1 rounded-full border border-white/10 p-1" role="group" aria-label="Choix de la langue" data-testid="blog-lang-switcher">
      <Globe className="w-3.5 h-3.5 text-muted-foreground ml-1.5" strokeWidth={1.5} />
      {langs.map((l) => (
        <button key={l.k} onClick={() => setLang(l.k)} data-testid={`blog-lang-${l.k}`}
          aria-pressed={lang === l.k} aria-label={l.l}
          className={`text-xs px-2 py-1 rounded-full transition-colors ${lang === l.k ? "bg-accent text-white" : "text-muted-foreground hover:text-white"}`}>
          {l.l}
        </button>
      ))}
    </div>
  );
};
